<template>
  <MultipleChoicesDropdown
    :title="title"
    :value="value"
    :show-clear-all="false"
    :single-choice="singleChoice"
    :search-enabled="true"
    :choices="stagesChoices"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import { stagesChoices } from 'services/stages'

export default {
  props: {
    value: { type: [String, Array] },
    title: { type: String, default: 'Company stage' },
    singleChoice: { type: Boolean, default: false },
  },
  data: () => ({
    stagesChoices,
  }),
  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>
